var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivePlanBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95312 83.7905L-0.789732 83.7905L3.95312 75.8857L3.95312 83.7905Z",
    fill: "#438E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8877 3.95282L83.002 -0.790039L83.0019 3.95282L75.8877 3.95282Z",
    fill: "#438E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.156 -1.47988e-06L0.0117166 49.1442L0.0117151 83L83.0117 0L49.156 -1.47988e-06Z",
    fill: "#59B72A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePlanBanner);
export default __webpack_public_path__ + "static/media/active_plan_banner.3a56e39cbd1091aa98b8997c0f6b2698.svg";
export { ForwardRef as ReactComponent };